
export interface SingleSetting {
    key: string;
    value: string;
}

export interface LocalDataSetting {
    key: string;
    group: SingleSetting[];
}

export interface SettingsSet {
    settings?: LocalDataSetting[];
}

export function SettingsSet_getSetting(set: SettingsSet, key: string): LocalDataSetting | null {
    let setting: LocalDataSetting | null = null;
    if (set.settings) {
        for (let s of set.settings) {
            if (s.key === key) {
                setting = s;
            }
        }
    }
    return setting;
}

export function SettingsSet_writeSetting(set: SettingsSet, key: string, group: SingleSetting[]): boolean {
    let setting = SettingsSet_getSetting(set, key);
    if (setting == null) {
        if (set.settings) {
            set.settings.push({
                key: key,
                group: group
            })
            return true;
        }
    } else {
        setting.group = group;
        return true;
    }

    return false;
}


export function SettingsSet_getSingleSetting(group: SingleSetting[], key: string): SingleSetting | null {

    for (let s of group) {
        if (s.key === key) {
            return s;
        }
    }
    return null;
}


export function SettingsSet_setSingleSetting(group: SingleSetting[], key: string, value: string): boolean {
    for (let s of group) {
        if (s.key === key) {
            s.value = value;
        }
    }
    group.push({ key: key, value: value })
    return true;
}
